// import React from 'react'
// import ReactDom from 'react-dom'
// import App from "./App"
// ReactDom.render(<App/>, document.getElementById("root"));
// export default function index() {
//   return (
//     <div></div>
//   )
// }

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

